<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="ded"><img alt="" class="image" src="images/1.jpg"/></p>
<p class="ded1"><i>For my dear friend<br/>Jill Sheppard</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication.vue?8532412c